<template>
    <BaseMap
        class="region-map"
        :layers="layers"
        :tiles="false"
        background="rgba(0,0,0,0.5)"
        :fit="fit"
        :fit-options="FIT_OPTIONS"
    >
        <ul v-if="legend.length" class="map-legend">
            <li v-if="legendCaption" class="caption">{{ legendCaption }}</li>
            <li v-for="item in legend" :key="item.label">
                <i :style="{ background: item.color }" />
                {{ item.label }}
            </li>
        </ul>
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </BaseMap>
</template>

<script>
import BaseMap from "js/components/base/BaseMap.vue";
import {
    bucketFraction,
    choroplethStyle,
    valueBuckets,
    regionStyleFor,
} from "js/components/maps/styles";

export default {
    name: "RegionMap",
    components: { BaseMap },
    props: {
        geos: {
            type: Array,
            default: () => [],
        },
        geoStyle: {
            type: Function,
            default: null,
        },
        fit: {
            type: Boolean,
            default: true,
        },
        legendFormat: {
            type: Function,
            default: null,
        },
        legendCaption: {
            type: String,
            default: null,
        },
        legendInverted: {
            type: Boolean,
            default: false,
        },
        bands: {
            type: Array,
            default: null,
        },
        formatValue: {
            type: Function,
            default: String,
        },
    },
    data() {
        return {
            FIT_OPTIONS: { maxZoom: 4, closeMaxZoom: 4 },
        };
    },
    computed: {
        buckets() {
            if (
                !this.geos.length ||
                typeof this.geos[0].getValue() !== "number"
            ) {
                return null;
            }

            return valueBuckets(
                this.geos.map((geo) => geo.getValue()),
                this.bands
            );
        },
        legend() {
            const format = this.legendFormat ?? this.formatValue;
            const items = (this.buckets ?? []).map((bucket) => {
                const [first, last] = this.legendInverted
                    ? [bucket.max, bucket.min]
                    : [bucket.min, bucket.max];

                return {
                    label:
                        first === last
                            ? format(first)
                            : `${format(first)}–${format(last)}`,
                    color: choroplethStyle(
                        bucketFraction(this.buckets, bucket.max)
                    )
                        .getFill()
                        .getColor(),
                };
            });

            return this.legendInverted ? items.reverse() : items;
        },
        layers() {
            return [
                {
                    id: "regions",
                    kind: "regions",
                    geos: this.geos,
                    style:
                        this.geoStyle ??
                        ((geo) => regionStyleFor(geo.getValue(), this.buckets)),
                },
            ];
        },
    },
};
</script>
